var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.077148px",
    height: "11.076904px",
    viewBox: "0 0 11.077148 11.076904",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-2.461914 -2.4615479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17506 8.00017L12.7253 4.44991L13.4575 3.71777C13.5655 3.60977 13.5655 3.43426 13.4575 3.32626L12.6741 2.54289C12.5661 2.43488 12.3906 2.43488 12.2826 2.54289L8.00017 6.82529L3.71777 2.54254C3.60977 2.43454 3.43426 2.43454 3.32626 2.54254L2.54254 3.32591C2.43454 3.43392 2.43454 3.60942 2.54254 3.71742L6.82529 8.00017L2.54254 12.2826C2.43454 12.3906 2.43454 12.5661 2.54254 12.6741L3.32591 13.4575C3.43392 13.5655 3.60942 13.5655 3.71742 13.4575L8.00017 9.17506L11.5504 12.7253L12.2826 13.4575C12.3906 13.5655 12.5661 13.5655 12.6741 13.4575L13.4575 12.6741C13.5655 12.5661 13.5655 12.3906 13.4575 12.2826L9.17506 8.00017Z",
    id: "Icon-Color",
    fill: "current",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1f83e89454a0952f5dce11d3cc97ac22.svg";
export { ForwardRef as ReactComponent };